import React, { useCallback, type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button/standard-button';
import UnlinkIcon from '@atlaskit/icon/glyph/unlink';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

type Props = {
	onClick: (analyticsEvent: UIAnalyticsEvent) => void;
};

const UnlinkButton = ({ onClick }: Props) => {
	const { formatMessage } = useIntl();

	const onClickCallback = useCallback(
		(event: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => {
			event.stopPropagation();
			fireUIAnalytics(analyticsEvent, 'dependencyUnlinkButton');
			onClick(analyticsEvent);
		},
		[onClick],
	);

	return (
		<Tooltip content={formatMessage(messages.unlink)}>
			<Button
				iconBefore={
					<UnlinkIcon
						label={formatMessage(messages.unlink)}
						size="small"
						testId="roadmap.timeline-table-kit.common.ui.dependency.unlink-button.unlink-button"
					/>
				}
				spacing="compact"
				appearance="subtle"
				onClick={onClickCallback}
			/>
		</Tooltip>
	);
};

export default UnlinkButton;
